export const saveToPortfolioAsyncModule = {
  importFn: () => import(/* webpackChunkName: "save-to-portfolio" */ './DialogContent'),
  cacheKey: 'save-to-portfolio',
}
